import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { ItemValidacaoMovimentacaoStruct } from '../../structs/financas/item-validacao-movimentacao.struct';
import { ValidacaoImportacaoMovimentacaoResponse } from '../../responses/financas/validacao-importacao-movimentacao.response';

@Injectable({
    providedIn: 'root',
})
export class ImportarLancamentoService extends CommonService {
    private readonly apiUrl = `${environment.urlApiFinancas}ImportarMovimentacao`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public validar(arquivoBase64: string, nomeArquivo: string): Observable<ValidacaoImportacaoMovimentacaoResponse> {
        return this.httpClient
            .post<ValidacaoImportacaoMovimentacaoResponse>(`${this.apiUrl}/validar`, { arquivoBase64, nomeArquivo }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public confirmar(itens: ItemValidacaoMovimentacaoStruct[]): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(`${this.apiUrl}/confirmar`, itens, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
